import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MediaInterface } from '@core/interfaces/media.interface';
import { SafeResourceUrlPipe } from '@modules/creator/pipes/safe-resource-url.pipe';

type IframeType = 'normal' | 'vimeo' | 'youtube'

@Component({
  templateUrl: './iframe.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'iframe',
  },
  imports: [
    SafeResourceUrlPipe,
    NgSwitchCase,
    NgSwitch,
  ],
})
export class IframeComponent implements OnInit {
  iframeType: IframeType;

  @Input() media: MediaInterface;

  ngOnInit() {
    this.setIframeType();
  }

  private setIframeType(): void {
    const url = this.media.urls.full;
    if (url.includes('youtube.') || url.includes('youtu.be/')) {
      this.iframeType = 'youtube';
    } else if (url.includes('player.vimeo')) {
      this.iframeType = 'vimeo';
    } else {
      this.iframeType = 'normal';
    }
  }
}
